import React, { Component } from 'react';
import Chart from '../charts/Chart';
import { donutMultiValue } from '../charts/templates/donutMultiValue';
import './DonutChartCard.css';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import _ from 'lodash';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { arrowDownwardIcon, arrowUpwardIcon } from '../../constants';
import { ChartUtils } from '../../util/ChartUtils';
import Tenant from '../../models/Tenant';
import DateTime from '../../models/DateTime';
import User from '../../models/User';
import Tooltip from '../shared/Tooltip';

class DonutChartCard extends Component {

  getValues = (arrOfArrays) => {
    return _.map(arrOfArrays, (arr) => {
      return arr[1];
    });
  };

  getDiffPercent = (stats, prevStats) => {
    if (!prevStats) {
      return null;
    }
    let current = ChartUtils.convertDataToHighchartsPieFormat(stats);
    let previous = ChartUtils.convertDataToHighchartsPieFormat(prevStats);
    current = this.getValues(current);
    previous = this.getValues(previous);
    return _.map(current, (val, index) => {
      return parseFloat((val - previous[index]).toFixed(2));
    });
  };

  formatTooltip = (tooltip) => {
    const { data, tooltipLabel } = this.props;
    const { color, key } = tooltip;
    let { percentage } = tooltip;

    // If we can't find the value, just show percent
    percentage = parseFloat(percentage.toFixed(2));
    let value = '';
    for (let d of data) {
      if (d.label === key) {
        value = d.value;
      }
    }

    // If we have the value though, add a space.
    // The value may be zero, which is valid, so we explicitly check
    if (value !== null && value !== undefined) {
      value += ' ';
    }

    // const percent = parseFloat(percentage.toFixed(1));
    return (`
<div class="p-0 d-flex">
  <div class="row no-gutters">
    <div class="col-1 h-100 d-flex">
      <div style="background: ${color}; min-width: 0.5rem; max-width: 0.5rem; min-height: 0.5rem; max-height: 0.5rem;" class="rounded-circle my-auto"></div>
    </div>
    <div class="col-11" style="padding-right: 0.75rem;">${key}:&nbsp;${value}
    ${!!tooltipLabel ? tooltipLabel + ' ' : ''}(${percentage}%)</div>
  </div>
</div>
`.trim());
  };

  render () {
    const { user, icon, title, data, loading, error, dateRange, onRefresh, prevData } = this.props;

    let range = '(All Time)';
    if (dateRange.value === 52) {
      range = '(Last Year)';
    } else if (dateRange.value === 12) {
      range = `(Last ${dateRange.value} Weeks)`;
    }
    const percentDiffs = this.getDiffPercent(data, prevData);
    const convertedData = ChartUtils.convertDataToHighchartsPieFormat(data);
    const isEmpty = ChartUtils.isPieChartDataEmpty(convertedData);

    const tenant = user ? User.hasTenant(user) ? User.getTenant(user) : null : null;
    const earliestTime = tenant ? Tenant.getEarliestActivityTime(tenant) : null;
    const activityTooltip = `Trending not available${earliestTime ? ` before ${DateTime.format(
      earliestTime, 'MMM DD, YYYY')}` : '.'}`;

    return (
      <div className="card donut-chart-card analytics-card-height">
        <div className="row header-container">
          <img src={ icon } alt="Icon" className="header-icon" />
          <span className="text-center">
            <div className="text-title header-text">{ title }</div>
            <div className="date-range-label subtitle">{ range }</div>
          </span>
        </div>
        { error
          ? <ErrorAndRefresh error="Unable to load data from server" onRefresh={ onRefresh } />
          : loading
            ? <LoadingAndPulse
              size={ 20 }
              color="#3D9AE2"
              whatIsLoading="chart"
              style={ { marginTop: '-6rem' } } /> //need to compensate for the margin-bottom that we need on the header-container to counteract Highcharts covering things up
            : (
              <div className="chart-container">
                <div className="chart">
                  <Chart
                    data={ convertedData }
                    isEmpty={ isEmpty }
                    chartType={ donutMultiValue }
                    tooltipFormatter={ this.formatTooltip }
                    chartId={ title } />
                </div>
                <div className="legend">
                  <ul className="row no-gutters fix-ie">
                    { _.map(convertedData, (item, index) => {
                      const label = item[0];
                      const percent = item[1];
                      const percentDiff = percentDiffs ? percentDiffs[index] : null;
                      return (
                        <li
                          className="col-xs-6 col-md-12 col-lg-6"
                          key={ item[0] }>
                          <div className="row no-gutters">
                            <div
                              className="rounded-circle my-auto mr-2"
                              style={ ChartUtils.colorDotStyleCreator(index, 10) } />
                            <div className="text-center my-auto font-size-xs font-color-med">{ label } - { percent }%</div>
                          </div>
                          {/* { (percentDiffs && percentDiffs.length) ? (
                            <div className="row no-gutters h-100 ml-3">
                              <div className="text-center my-auto font-size-xs">
                                <i
                                  className={ `material-icons
                                  ${percentDiff === 0 && 'invisible'}
                                  ${percentDiff !== 0 ?
                                    percentDiff > 0
                                      ? 'positive-change-color'
                                      : 'negative-change-color'
                                    : ''}` }>
                                  { percentDiff > 0 ? arrowUpwardIcon : arrowDownwardIcon }
                                </i>
                              </div>
                              <div
                                className={ `text-center my-auto font-size-xs font-color-light
                                  ${percentDiff !== 0 ?
                                  percentDiff > 0
                                    ? 'positive-change-color'
                                    : 'negative-change-color'
                                  : ''}` }>
                                { percentDiff !== 0 ? `${percentDiff}%` : 'No change' }
                              </div>
                            </div>
                          ) : (
                            <Tooltip tooltip={ activityTooltip }>
                              <div className="font-size-xs font-color-med">
                                Trend not available
                              </div>
                            </Tooltip>
                          ) } */}
                        </li>
                      );
                    }) }
                  </ul>
                </div>
                

              </div>
            )
        }
      </div>
    );
  }
}

export default DonutChartCard;

